(function () {
  if (window.__auReviewJumpBound) return;
  window.__auReviewJumpBound = true;

  function jump() {
    var t = document.querySelector(
      '[data-oke-widget], [data-oke-container], .okeReviews-reviews-main, .okeReviews-widget'
    );
    if (!t) return false;
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function activate() {
    if (jump()) return;
    var n = 0;
    var id = setInterval(function () {
      if (jump() || ++n >= 20) clearInterval(id);
    }, 150);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-review-card-link]')) {
      activate();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    if (!e.target.closest || !e.target.closest('[data-review-card-link]')) return;
    e.preventDefault();
    activate();
  });
})();
